/**
 * Обработчик формы регистрации
 */
import { disableButton, enableButton } from '@commonJs/utils';

$(document).on('submit', '.registration-form', function (e) {
    e.preventDefault();

    const targetForm = $(this);
    const button = targetForm.find('button');

    $.ajax({
        type: 'POST',
        url: targetForm.attr('action'),
        data: targetForm.serialize(),
        beforeSend: function () {
            disableButton(button);
        },
        success: function (response) {
            showErrors(targetForm, {});
            const event = {
                event: 'sc_sign_up',
                method: 'email',
                game_player_id: response.playerId,
                social_player_id: response.socialId,
            };
            console.log('ga4', event);
            PushDataToGtm(event);

            location.href = response.redirectUri;
        },
        error: function (errors) {
            showErrors(targetForm, JSON.parse(errors.responseText));
        },
        complete: function () {
            enableButton(button);
        },
    });
});
